import { render, staticRenderFns } from "./WillAllChildrenBeneficiariesYN.vue?vue&type=template&id=301adc46"
import script from "./WillAllChildrenBeneficiariesYN.vue?vue&type=script&lang=js"
export * from "./WillAllChildrenBeneficiariesYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports